import { BuildClass } from '../../../universal';
import { React } from '../../lib';
export const ButtonGroup = (props) => (React.createElement("div", { className: BuildClass(['inline-flex overflow-hidden', props.className]) }, props.options.map(option => {
    const isActive = option.value === props.value;
    return (React.createElement("button", { key: option.value, type: "button", disabled: option.disabled, onClick: () => {
            if (!option.disabled) {
                props.onUpdate(option.value);
            }
        }, style: isActive
            ? {
                borderBottomColor: props.activeUnderlineColour ?? '#1a73e8',
            }
            : undefined, className: BuildClass({
            'px-2 pt-[2px] pb-0': true,
            'text-xs uppercase tracking-[-0.2px] leading-[16px]': true,
            'border-b-2 border-transparent': true,
            'text-[#444]': true,
            'cursor-pointer': true,
            'transition-colors duration-150': true,
            'text-neutral-600': !isActive,
            'hover:border-neutral-400/70 hover:text-[#222]': !isActive,
            'text-[#222]': isActive,
            'opacity-40 cursor-not-allowed': option.disabled ?? false,
            'focus:outline-hidden': true,
        }) }, option.label));
})));
//# sourceMappingURL=button-group.js.map